<template>
  <div>
    <!-- opacity 0 input to trigger via dial button -->
    <input
      type="file"
      accept="image/*"
      id="capture"
      ref="capture"
      capture="camera"
      v-on:change="handlePhoto"
    />
    <md-speed-dial
      md-open="click"
      class="md-fab-bottom-right"
      md-theme="default"
    >
      <md-button class="md-fab" md-fab-trigger>
        <md-icon md-icon-morph>close</md-icon>
        <md-icon>add</md-icon>
      </md-button>

      <md-button class="md-fab md-mini" v-on:click.native="activateMic()">
        <md-icon>mic</md-icon>
      </md-button>

      <md-button class="md-fab md-mini" v-on:click.native="startBarcode()">
        <md-icon id="barcode" md-src="static/icons/barcode.svg"></md-icon>
      </md-button>

      <md-button class="md-fab md-mini" v-on:click.native="takePhoto()">
        <md-icon>photo_camera</md-icon>
      </md-button>
    </md-speed-dial>
  </div>
</template>

<script>
import { storage, auth, DB_ROOT } from "@/helpers/firebase";
import { speak, listen } from "@/helpers/speech";
import { products } from "@/models/Item";

export default {
  props: ["items"],
  methods: {
    takePhoto() {
      this.$refs.capture.click();
    },
    handlePhoto(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      const file = files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.$root.$emit("imageCaptured");
        storage
          .ref(
            `${DB_ROOT}/lists/${this.$route.params.id}/items/${auth.currentUser.uid}`
          )
          .put(file);
      };
      reader.readAsDataURL(file);
    },
    startBarcode() {
      this.$root.$emit("startBarcode");
    },
    activateMic(intro = "Dictez votre liste") {
      speak(intro, () => {
        listen((t, recognizer) => {
          console.log(t);
          // stop
          if (t.match(/fin|termin|stop|non/gi)) {
            recognizer.stop();
            speak("Très bien merci.");
            return;
          }

          if (t.match(/liste/gi)) {
            recognizer.stop();
            this.speakList();
            return;
          }

          // ajouter
          const productsCopy = products.slice(0);
          // longest to shortest for pommes de terre before pommes
          productsCopy.sort((a, b) => {
            if (a.name.length === b.name.length) {
              return b.name.localeCompare(a.name);
            } else {
              return b.name.length - a.name.length;
            }
          });
          productsCopy.forEach(i => {
            const r = new RegExp(i.name.toLowerCase().replace(/s/, ".?"), "gi");
            if (t.match(r)) {
              t = t.replace(r, "");
              this.$root.$emit("addToList", i);
            }
          });
          // TODO handle unknown
          // TODO remove stop words
          // this.search = t.trim();
          // enlever
          // TODO: handle remove
        });
      });
    },
    speakList() {
      let txt = `Il n'y a rien dans la liste!`;
      const activeItems = Object.values(this.items).filter(i => !i.checked);
      if (activeItems.length) {
        txt = "Dans la liste il y a: ";
        txt += activeItems.map(i => i.name).join(". ");
        txt += ".";
      }
      speak(txt, () => {
        this.activateMic("Voulez-vous ajouter quelque chose?");
      });
    }
  }
};
</script>

<style>
#capture {
  opacity: 0;
  width: 0;
}
</style>
